import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import InputString from '../UI/Control/InputString';
import classes from './../TrialstatNoto.module.css';
import DataTable from "react-data-table-component";
import customStyles from '../customStyles';
import NoData from '../NoData';

const OutcomeEmailAuditModal = (props) => {
    const [show, setShow] = useState(false);
    const [rowData, setData] = useState([]);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        fetchData();
        setShow(true);
    };

    const columns = [
        {
            name: "HisContentID",
            selector: row => row.HisContentID,
            cellExport: row => row.HisContentID,
            sortable: true,
            center: true,
            omit:true
        },
        {
            name: "Subject",
            selector: row => row.Subject,
            cellExport: row => row.Subject,
            sortable: true,
            center: true,
            width: "10%",
            wrap: true
        },
        {
            name: "Description",
            selector: row => row.Description,
            cellExport: row => row.Description,
            sortable: true,
            center: true,
            width: "16%",
            wrap: true
        },
        {
            name: "Content",
            selector: row => row.EmailContent,
            cellExport: row => row.EmailContent,
            sortable: true,
            center: true,
            width: "23%",
            wrap:true
        },
        {
            name: "Version Number",
            selector: row => row.VerNumber,
            cellExport: row => row.VerNumber,
            sortable: true,
            center: true,
            width: "8%",
            wrap: true
        },
        {
            name: "Change Reason",
            selector: row => row.ChangeReason,
            cellExport: row => row.ChangeReason,
            sortable: true,
            center: true,
            width: "19%",
            wrap: true
        },
        {
            name: "User",
            selector: row => row.LastModifiedUser == '' ? row.CreationUser : row.LastModifiedUser,
            cellExport: row => row.LastModifiedUser == '' ? row.CreationUser : row.LastModifiedUser,
            sortable: true,
            center: true,
            width: "12%",
            wrap: true
        },
        {
            name: "Date",
            selector: row => row.LastModifiedDate == '' ? row.CreationDate : row.LastModifiedDate,
            cellExport: row => row.LastModifiedDate == '' ? row.CreationDate : row.LastModifiedDate,
            sortable: true,
            center: true,
            width: "12%",
            wrap: true
        }
    ];

    const fetchData = () => {
        fetch('api/OutcomeNotification/GetOutcomeEmailAudit?mappingId=' + props.mappingId)
            .then(response => response.json())
            .then(data => {
                setData(data);
            });
    }

    const [q, setQ] = useState('');
    function search(rows) {
        const columns = ['Subject', 'Description', 'EmailContent', 'ChangeReason', 'LastModifiedUser', 'LastModifiedDate', 'VerNumber'];
        if (q != '') {
            let selString = q.toString();
            let searchText = selString.toLowerCase().split(",");
            return rows.filter((row) => {
                return columns.some((column) => {
                    if (searchText.length > 1)
                        return searchText.indexOf(row[column].toString().toLowerCase()) > -1;
                    else
                        return row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1;
                })
            })
        }
        else
            return rows;
    }
    const searchChangeHandler = (e) => {
        setQ(e.target.value);
    }

    return (
        <>
            <Button variant="secondary" className="btn btn-success" style={props.style} onClick={handleShow}> {props.text} </Button>

            <Modal centered
                show={show}
                onHide={handleClose}
                dialogClassName={classes.TSModalDailog_TwentyTwo} backdrop="static">

                <Modal.Header closeButton>
                    <Modal.Title style={{ textAlign: "center", display: "block" }}>Audit for {props.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: "60vh", maxHeight: "60vh", overflowY: "scroll" }}>
                    <div className="row">
                        <div className="col-sm-1" style={{ width: "4%" }}/>
                        <div className="col-sm-10" style={{ width: "95%" }}>
                            <div className="row" style={{ marginBottom: "10px" }}>
                                <div className="col-sm-7" />
                                <div className="col-sm-5">
                                    <InputString id="txtSearch" onChangeHandler={searchChangeHandler} placeholder="Search" />
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: "10px" }}>
                                <div className="tableContainer">
                                    {search(rowData).length > 0 ? <DataTable
                                        columns={columns}
                                        data={search(rowData)}
                                        className="table table-striped table-bordered table-hover"
                                        customStyles={customStyles}
                                        striped
                                        pagination
                                        paginationPerPage={50}
                                        paginationRowsPerPageOptions={[20, 50, 100]}
                                    /> : <NoData headers={columns} />}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-1" style={{ width: "4%" }} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-danger" variant="secondary" onClick={handleClose}>
                        Close
                        </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default OutcomeEmailAuditModal;